export enum ETypeRequest {
  ege_lead_free_lesson = 'ege_lead_free_lesson',
  ege_lead_free_test = 'ege_lead_free_test',
  ege_lead_consult = 'ege_lead_consult',
  ege_lead_request = 'ege_lead_request',
  oge_lead_request = 'oge_lead_request',
  proforientation_request = 'proforientation_request',
  select_institution_request = 'select_institution_request',
}
